import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import {
    BillingItem,
    BillingQueryDTO,
    DashboardBillingResponseDTO,
    DocumentTypes
} from 'pages/FinancialManagement/components/Billing/interface'
import { removeEmptyValues } from 'utils/removeEmptyValues'
import api from './api'

const { ENDPOINT_REPORT_CSV } = environments

// GESTÃO FATURAMENTO
export const getDataBilling = async (
    query: BillingQueryDTO
): Promise<AxiosResponse<BillingItem[]>> => {
    return api.get(
        `${ENDPOINT_REPORT_CSV}/contratos/operacoes/faturamento-eventos?${new URLSearchParams(
            query as unknown as Record<string, string>
        )}`
    )
}

export const getDataDashboardBilling = async (
    query: Partial<BillingQueryDTO>
): Promise<AxiosResponse<DashboardBillingResponseDTO>> => {
    return api.get(
        `${ENDPOINT_REPORT_CSV}/graficos/operacoes/faturamento?${new URLSearchParams(
            query as unknown as Record<string, string>
        )}`
    )
}

export const getFilesBillingReports = async (
    query: Omit<BillingQueryDTO, 'pagina' | 'limite'>,
    type: DocumentTypes
): Promise<AxiosResponse<BlobPart>> => {
    const removeEmptyValuesQuery = removeEmptyValues(query)
    const urlParams = new URLSearchParams({
        ...removeEmptyValuesQuery,
        tipo: type
    })

    return api.get(
        `${ENDPOINT_REPORT_CSV}/contratos/operacoes/faturamento-relatorios?${urlParams}`
    )
}

export const getDashboardBillingReports = async (
    query: Omit<BillingQueryDTO, 'pagina' | 'limite'>,
    base64: any
): Promise<AxiosResponse<BlobPart>> => {
    const removeEmptyValuesQuery = removeEmptyValues(query)
    const urlParams = new URLSearchParams({ ...removeEmptyValuesQuery })

    const payload = { graficosBase64: base64 }
    return api.post(
        `${ENDPOINT_REPORT_CSV}/graficos/operacoes/faturamento/exportar?${urlParams}`,
        payload
    )
}
